export default function clearSelectionsStyles(activeObject, styleKey) {
  for (let line in activeObject.styles) {
    for (let char in activeObject.styles[line]) {
      delete activeObject.styles[line][char][styleKey];
    }
  }
}
